import styled from "styled-components";

export const ContainerContentSimulation = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px 32px 32px; 

    display: flex;
    justify-content: center;
    align-items: flex-start;

    @media (max-width: 768px) {
        padding: 24px 0 32px;
    }
`